import { render, staticRenderFns } from "./ManageWarrantsWithoutDebtor.vue?vue&type=template&id=35c9a8bd&scoped=true"
import script from "./ManageWarrantsWithoutDebtor.vue?vue&type=script&lang=js"
export * from "./ManageWarrantsWithoutDebtor.vue?vue&type=script&lang=js"
import style0 from "./ManageWarrantsWithoutDebtor.vue?vue&type=style&index=0&id=35c9a8bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c9a8bd",
  null
  
)

export default component.exports